<sidebar></sidebar>
<main>
    <router-outlet class="main-float"></router-outlet>
</main>
<settings></settings>